'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionTag = exports.getUserSessionId = exports.getAppSessionId = exports.getPlatform = exports.getClientVersion = exports.getClient = exports.getOsVersion = exports.getOs = exports.getReactIntlDefaultLocale = exports.getLocalePrefix = exports.getDefaultLocalePrefix = exports.getLocale = exports.getLocaleVersion = exports.getDefaultLocale = exports.getOidcRedirecting = exports.getOidcReady = exports.getCompanyName = exports.getMemberId = exports.getMemberHash = exports.getSite = exports.getIsAuthenticated = exports.getModuleQueryParams = exports.getModuleCache = exports.getModuleConfig = exports.getActiveScreenKey = exports.getElementId = exports.getModuleId = exports.getIsStandalone = exports.getIsReady = exports.getScreenKeys = exports.getOidcError = exports.getOidcDisableAutoSignoutRedirect = exports.getOidcDisableAutoSigninRedirect = exports.initialState = undefined;
exports.default = moduleReducer;

var _immutable = require('immutable');

var _ScreenKeyConst = require('../../components/screen/ScreenKeyConst');

var _OnAuthenticationSuccessAction = require('./actions/OnAuthenticationSuccessAction');

var _ScreenKeyUpdateAction = require('../../components/module/actions/ScreenKeyUpdateAction');

var _AppEntryLoadDataAction = require('../../components/module/actions/AppEntryLoadDataAction');

var _OnModuleReadyAction = require('./actions/OnModuleReadyAction');

var _reduxOidc = require('redux-oidc');

var _OidcService = require('../../services/OidcService');

var _OidcCallbackSuccessRedirectAction = require('../../components/oidc/actions/OidcCallbackSuccessRedirectAction');

var _OidcRedirectingAction = require('../../components/oidc/actions/OidcRedirectingAction');

var _OidcErrorAction = require('../../components/oidc/actions/OidcErrorAction');

var _OidcDisableAutoSigninSignoutRedirect = require('../../components/oidc/actions/OidcDisableAutoSigninSignoutRedirect');

var _ShowDialogAction = require('../../components/dialog/actions/ShowDialogAction');

var _HideDialogAction = require('../../components/dialog/actions/HideDialogAction');

var _SetModuleConfigAction = require('../../components/module/actions/SetModuleConfigAction');

var _RemoveModuleConfigAction = require('../../components/module/actions/RemoveModuleConfigAction');

var _SetModuleCacheAction = require('../../components/module/actions/SetModuleCacheAction');

var _RemoveModuleCacheAction = require('../../components/module/actions/RemoveModuleCacheAction');

var _SetModuleQueryParamsAction = require('./actions/SetModuleQueryParamsAction');

var _ModuleEventBusService = require('../../services/ModuleEventBusService');

var initialState = exports.initialState = (0, _immutable.Map)({
  isReady: false,
  isStandalone: false,
  moduleId: '',
  elementId: '',
  screenKeys: (0, _immutable.Stack)(),
  config: (0, _immutable.Map)(),
  cache: (0, _immutable.Map)(),
  queryParams: (0, _immutable.Map)(),
  manageAuth: (0, _immutable.Record)({
    isAuthenticated: false,
    site: '',
    memberHash: '',
    memberId: '',
    companyName: ''
  })(),
  oidcAuth: (0, _immutable.Record)({
    oidcReady: false,
    oidcRedirecting: false,
    oidcDisableAutoSigninRedirect: false,
    oidcDisableAutoSignoutRedirect: false,
    oidcError: null
  })(),
  intl: (0, _immutable.Record)({
    locale: '',
    localeVersion: '',
    defaultLocale: '',
    defaultLocalePrefix: '',
    localePrefix: '',
    reactIntlDefaultLocale: ''
  })(),
  userAgent: (0, _immutable.Record)({
    os: '',
    osVersion: '',
    client: '',
    clientVersion: '',
    platform: ''
  })(),
  session: (0, _immutable.Record)({
    appSessionId: '',
    userSessionId: '',
    sessionTag: ''
  })()
});

var getOidcDisableAutoSigninRedirect = exports.getOidcDisableAutoSigninRedirect = function getOidcDisableAutoSigninRedirect(state) {
  return state.getIn(['oidcAuth', 'oidcDisableAutoSigninRedirect']);
};

var getOidcDisableAutoSignoutRedirect = exports.getOidcDisableAutoSignoutRedirect = function getOidcDisableAutoSignoutRedirect(state) {
  return state.getIn(['oidcAuth', 'oidcDisableAutoSignoutRedirect']);
};

var getOidcError = exports.getOidcError = function getOidcError(state) {
  return state.getIn(['oidcAuth', 'oidcError']);
};

/**
 * Returns the entire screenKeys stack
 * @param {Map<string,any>} state 
 * @returns {Stack<string>}
 */
var getScreenKeys = exports.getScreenKeys = function getScreenKeys(state) {
  return state.get('screenKeys');
};

function moduleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reduxOidc.USER_EXPIRED:
      {
        if (!getOidcDisableAutoSigninRedirect(state)) {
          // avoid endless loop of attempting to log in when in callback
          if (!(0, _OidcService.isRedirectUri)()) {
            (0, _ModuleEventBusService.publish)('USER_EXPIRED', undefined, _ScreenKeyConst.MODULE_SCREEN_KEY);
          }
        }
        return state;
      }
    case _reduxOidc.USER_SIGNED_OUT:
      {
        if (!getOidcDisableAutoSignoutRedirect(state)) {
          // sign out of app when user signs out of STS elsewhere
          (0, _ModuleEventBusService.publish)('USER_SIGNED_OUT', undefined, _ScreenKeyConst.MODULE_SCREEN_KEY);
        }
        return state;
      }
    case _reduxOidc.USER_FOUND:
      {
        if (!action.payload.state) {
          // if not coming from callback component redirect, then ready
          return state.setIn(['oidcAuth', 'oidcReady'], true);
        } else {
          // if coming from callback component, wait until url is updated and OIDC_CALLBACK_SUCCESS_REDIRECT action is called
          return state;
        }
      }
    case _OidcCallbackSuccessRedirectAction.OIDC_CALLBACK_SUCCESS_REDIRECT:
      {
        return state.setIn(['oidcAuth', 'oidcReady'], true);
      }
    case _OidcRedirectingAction.OIDC_REDIRECTING:
      {
        return state.setIn(['oidcAuth', 'oidcRedirecting'], action.oidcRedirecting);
      }
    case _OidcErrorAction.OIDC_ERROR:
      {
        var newState = state.setIn(['oidcAuth', 'oidcRedirecting'], false);
        return newState.setIn(['oidcAuth', 'oidcError'], action.error);
      }
    case _OidcDisableAutoSigninSignoutRedirect.OIDC_DISABLE_AUTO_SIGNIN_SIGNOUT_REDIRECT:
      {
        var _newState = state.setIn(['oidcAuth', 'oidcDisableAutoSigninRedirect'], action.oidcDisableAutoSigninRedirect);
        return _newState.setIn(['oidcAuth', 'oidcDisableAutoSignoutRedirect'], action.oidcDisableAutoSignoutRedirect);
      }
    case _SetModuleConfigAction.SET_MODULE_CONFIG_ACTION:
      {
        return state.setIn(['config'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveModuleConfigAction.REMOVE_MODULE_CONFIG_ACTION:
      {
        return state.deleteIn(['config'].concat(action.path));
      }
    case _SetModuleCacheAction.SET_MODULE_CACHE_ACTION:
      {
        return state.setIn(['cache'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveModuleCacheAction.REMOVE_MODULE_CACHE_ACTION:
      {
        return state.deleteIn(['cache'].concat(action.path));
      }
    case _SetModuleQueryParamsAction.SET_MODULE_QUERY_PARAMS_ACTION:
      {
        return state.set('queryParams', (0, _immutable.fromJS)(action.value));
      }
    case _AppEntryLoadDataAction.APP_ENTRY_LOAD_DATA_ACTION:
      {
        var _newState2 = state.set('isStandalone', action.isStandalone);
        _newState2 = _newState2.set('moduleId', action.moduleId);
        _newState2 = _newState2.set('elementId', action.elementId);
        _newState2 = _newState2.setIn(['manageAuth', 'isAuthenticated'], action.isAuthenticated);
        _newState2 = _newState2.setIn(['manageAuth', 'site'], action.site);
        _newState2 = _newState2.setIn(['manageAuth', 'memberHash'], action.memberHash);
        _newState2 = _newState2.setIn(['manageAuth', 'memberId'], action.memberId);
        _newState2 = _newState2.setIn(['manageAuth', 'companyName'], action.companyName);
        _newState2 = _newState2.setIn(['intl', 'locale'], action.locale);
        _newState2 = _newState2.setIn(['intl', 'localeVersion'], action.localeVersion);
        _newState2 = _newState2.setIn(['intl', 'defaultLocale'], action.defaultLocale);
        _newState2 = _newState2.setIn(['intl', 'defaultLocalePrefix'], action.defaultLocalePrefix);
        _newState2 = _newState2.setIn(['intl', 'localePrefix'], action.localePrefix);
        _newState2 = _newState2.setIn(['intl', 'reactIntlDefaultLocale'], action.reactIntlDefaultLocale);
        _newState2 = _newState2.setIn(['userAgent', 'os'], action.os);
        _newState2 = _newState2.setIn(['userAgent', 'osVersion'], action.osVersion);
        _newState2 = _newState2.setIn(['userAgent', 'client'], action.client);
        _newState2 = _newState2.setIn(['userAgent', 'clientVersion'], action.clientVersion);
        _newState2 = _newState2.setIn(['userAgent', 'platform'], action.platform);
        _newState2 = _newState2.setIn(['session', 'appSessionId'], action.appSessionId);
        _newState2 = _newState2.setIn(['session', 'userSessionId'], action.userSessionId);
        return _newState2.setIn(['session', 'sessionTag'], action.sessionTag);
      }
    case _OnModuleReadyAction.ON_MODULE_READY_ACTION:
      {
        return state.set('isReady', action.isReady);
      }
    case _OnAuthenticationSuccessAction.ON_AUTHENTICATION_SUCCESS_ACTION:
      {
        var _newState3 = state.setIn(['manageAuth', 'isAuthenticated'], action.isAuthenticated);
        _newState3 = _newState3.setIn(['manageAuth', 'site'], action.site);
        _newState3 = _newState3.setIn(['manageAuth', 'memberHash'], action.memberHash);
        _newState3 = _newState3.setIn(['manageAuth', 'memberId'], action.memberId);
        return _newState3.setIn(['manageAuth', 'companyName'], action.companyName);
      }
    case _ScreenKeyUpdateAction.ADD_SCREEN_KEY_ACTION:
      {
        var screenKeys = getScreenKeys(state);
        screenKeys = screenKeys.push(action.screenKey);
        return state.set('screenKeys', screenKeys);
      }
    case _ShowDialogAction.SHOW_DIALOG_ACTION:
      {
        var _screenKeys = getScreenKeys(state);
        _screenKeys = _screenKeys.push(action.dialogId);
        return state.set('screenKeys', _screenKeys);
      }
    case _ScreenKeyUpdateAction.REMOVE_SCREEN_KEY_ACTION:
    case _HideDialogAction.HIDE_DIALOG_ACTION:
      {
        var _screenKeys2 = getScreenKeys(state);
        _screenKeys2 = _screenKeys2.pop();
        return state.set('screenKeys', _screenKeys2);
      }
    default:
      {
        return state;
      }
  }
}

var getIsReady = exports.getIsReady = function getIsReady(state) {
  return state.get('isReady');
};

var getIsStandalone = exports.getIsStandalone = function getIsStandalone(state) {
  return state.get('isStandalone');
};

var getModuleId = exports.getModuleId = function getModuleId(state) {
  return state.get('moduleId');
};

var getElementId = exports.getElementId = function getElementId(state) {
  return state.get('elementId');
};

/**
 * Returns the active screenKey from top of stack.
 * If stack is empty, defaults to ACTIVE_SCREEN_KEY
 * @param {Map<string,any>} state
 * @returns {string}
 */
var getActiveScreenKey = exports.getActiveScreenKey = function getActiveScreenKey(state) {
  var screenKey = state.get('screenKeys').peek();
  return screenKey ? screenKey : _ScreenKeyConst.ACTIVE_SCREEN_KEY;
};

/**
 * @param {Map<string,any>} state
 * @param {string[]?} [path]
 */
var getModuleConfig = exports.getModuleConfig = function getModuleConfig(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return state.getIn(['config'].concat(path));
};

/**
 * @param {Map<string,any>} state
 * @param {string[]?} [path]
 */
var getModuleCache = exports.getModuleCache = function getModuleCache(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return state.getIn(['cache'].concat(path));
};

/**
 * @param {Map<string,any>} state
 * @param {string[]?} [path]
 */
var getModuleQueryParams = exports.getModuleQueryParams = function getModuleQueryParams(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return state.getIn(['queryParams'].concat(path));
};

var getIsAuthenticated = exports.getIsAuthenticated = function getIsAuthenticated(state) {
  return state.getIn(['manageAuth', 'isAuthenticated']);
};

var getSite = exports.getSite = function getSite(state) {
  return state.getIn(['manageAuth', 'site']);
};

var getMemberHash = exports.getMemberHash = function getMemberHash(state) {
  return state.getIn(['manageAuth', 'memberHash']);
};

var getMemberId = exports.getMemberId = function getMemberId(state) {
  return state.getIn(['manageAuth', 'memberId']);
};

var getCompanyName = exports.getCompanyName = function getCompanyName(state) {
  return state.getIn(['manageAuth', 'companyName']);
};

var getOidcReady = exports.getOidcReady = function getOidcReady(state) {
  return state.getIn(['oidcAuth', 'oidcReady']);
};

var getOidcRedirecting = exports.getOidcRedirecting = function getOidcRedirecting(state) {
  return state.getIn(['oidcAuth', 'oidcRedirecting']);
};

var getDefaultLocale = exports.getDefaultLocale = function getDefaultLocale(state) {
  return state.getIn(['intl', 'defaultLocale']);
};

var getLocaleVersion = exports.getLocaleVersion = function getLocaleVersion(state) {
  return state.getIn(['intl', 'localeVersion']);
};

var getLocale = exports.getLocale = function getLocale(state) {
  return state.getIn(['intl', 'locale']);
};

var getDefaultLocalePrefix = exports.getDefaultLocalePrefix = function getDefaultLocalePrefix(state) {
  return state.getIn(['intl', 'defaultLocalePrefix']);
};

var getLocalePrefix = exports.getLocalePrefix = function getLocalePrefix(state) {
  return state.getIn(['intl', 'localePrefix']);
};

var getReactIntlDefaultLocale = exports.getReactIntlDefaultLocale = function getReactIntlDefaultLocale(state) {
  return state.getIn(['intl', 'reactIntlDefaultLocale']);
};

var getOs = exports.getOs = function getOs(state) {
  return state.getIn(['userAgent', 'os']);
};

var getOsVersion = exports.getOsVersion = function getOsVersion(state) {
  return state.getIn(['userAgent', 'osVersion']);
};

var getClient = exports.getClient = function getClient(state) {
  return state.getIn(['userAgent', 'client']);
};

var getClientVersion = exports.getClientVersion = function getClientVersion(state) {
  return state.getIn(['userAgent', 'clientVersion']);
};

var getPlatform = exports.getPlatform = function getPlatform(state) {
  return state.getIn(['userAgent', 'platform']);
};

var getAppSessionId = exports.getAppSessionId = function getAppSessionId(state) {
  return state.getIn(['session', 'appSessionId']);
};

var getUserSessionId = exports.getUserSessionId = function getUserSessionId(state) {
  return state.getIn(['session', 'userSessionId']);
};

var getSessionTag = exports.getSessionTag = function getSessionTag(state) {
  return state.getIn(['session', 'sessionTag']);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/module/ModuleReducer.js
// module id = 28
// module chunks = 10